<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs
          headline="Danh sách"
          :link="[
            { text: 'Cơ sở vật chất', href: '/facility' },
            { text: 'Đề xuất mua sắm thiết bị', href: '/facility/proposals' }
          ]"
        />
      </div>
      <div class="flex-center">
        <v-btn depressed dark color="primary" @click="newDialog = !newDialog">
          <v-icon left>mdi-plus</v-icon> Tạo đề xuất mới
        </v-btn>
      </div>
    </div>

    <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
      <ProposalFilter @onFilterChanged="onFilterChange" />
    </v-card>

    <v-card outlined class="mx-4 elevation-0">
      <ProposalDataTable ref="proposalDataTable" />
    </v-card>

    <ProposalNewDialog :state="newDialog" @updated="onFilterChange()" />
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import ProposalDataTable from '@/modules/facility/proposal/ProposalDataTable.vue'
import ProposalFilter from '@/modules/facility/proposal/ProposalFilter.vue'

export default {
  name: 'FacilityProposals',
  components: {
    Breadcrumbs,
    ProposalDataTable,
    ProposalFilter,
    ProposalNewDialog: () => import('@/modules/facility/proposal/ProposalNewDialog.vue')
  },
  data() {
    return {
      newDialog: false
    }
  },
  methods: {
    async refresh(query) {
      this.$refs.proposalDataTable.refresh(query)
    },
    onFilterChange(query) {
      this.refresh(query)
    }
  }
}
</script>
